
const HolidayInfoBanner = () => {
  const today = new Date();

  const isXmasRange = today >= new Date(2026, 12, 21) && today <= new Date(2027, 1, 1);
  const isEaster = today >= new Date(2026, 3, 27) && today <= new Date(2026, 4, 6);
  const isSummer = today >= new Date(2025, 7, 6) && today <= new Date(2025, 7, 24);

  return (
    <div>
      {isXmasRange && <div className="alert alert-info" role="alert"> I høytiden kan det forventes noe lengre tid før endringer blir publisert. Vi beklager dette. </div>}
      {isEaster && <div className="alert alert-info" role="alert"> God påske! I høytiden kan det ta litt tid før endringer blir publisert. Vi beklager dette. </div>}
      {isSummer && <div className="alert alert-info" role="alert"> På grunn av ferieavvikling i sommer kan det ta litt tid før endringer blir publisert. Vi beklager dette. </div>}
    </div>
  );
};

export default HolidayInfoBanner;